import { ChevronDown, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import MarkdownRenderer from './MarkdownRenderer';
interface Block {
  type: string;
  content: string;
  id: string;
}
interface ThinkingSectionProps {
  thinkBlocks: Block[];
  isThinkingCollapsed: boolean;
  isToolCollapsed: Set<string>;
  onToggleThinking: (groupIndex: number) => void;
  onToggleTool: (toolId: string) => void;
  groupIndex?: number;
}
/**
 * ThinkingSection Component
 * 渲染思考过程区域，包括思考内容和工具调用
 */
export default function ThinkingSection({
  thinkBlocks,
  isThinkingCollapsed,
  isToolCollapsed,
  onToggleThinking,
  onToggleTool,
  groupIndex = 0,
}: ThinkingSectionProps) {
  const { t } = useTranslation();

  if (thinkBlocks.length === 0) {
    return null;
  }
  return (
    <div className="thinking-section mb-3">
      {/* Thinking header and content container */}
      <div className="border border-gray-300 rounded-lg overflow-hidden">
        {/* Thinking header - collapsible style matching screenshot */}
        <button
          onClick={() => onToggleThinking(groupIndex)}
          className={cn(
            'w-full flex items-center justify-between px-3 py-2.5 hover:bg-white transition-colors text-sm text-gray-700',
            isThinkingCollapsed ? 'bg-transparent' : 'bg-white'
          )}
        >
          <span className="font-medium">
            {t('thoughtProcess.thoughtProcess')}
          </span>
          {isThinkingCollapsed ? (
            <ChevronDown size={16} className="text-gray-500" />
          ) : (
            <ChevronDown
              size={16}
              className="text-gray-500 transform rotate-180"
            />
          )}
        </button>

        {/* Thinking content */}
        {!isThinkingCollapsed && (
          <div className="thinking-content bg-white px-6 py-4 text-sm whitespace-normal break-words">
            {thinkBlocks.map((block, index) => (
              <div
                key={block.id || `block-${index}`}
                className={cn(`block-${block.type}`, 'thinking-block')}
              >
                {block.type === 'call' || block.type === 'result' ? (
                  <div>
                    <button
                      onClick={() => onToggleTool(block.id + index)}
                      className="flex items-center gap-1 text-base text-gray-500 hover:text-gray-700 transition-colors"
                    >
                      {isToolCollapsed.has(block.id + index) ? (
                        <ChevronDown size={14} />
                      ) : (
                        <ChevronRight size={14} />
                      )}
                      <span className="font-medium">
                        {block.type === 'call'
                          ? t('thoughtProcess.tool')
                          : t('thoughtProcess.toolResult')}
                      </span>
                    </button>
                    {isToolCollapsed.has(block.id + index) && (
                      <MarkdownRenderer
                        content={block.content}
                        className="text-gray-700"
                      />
                    )}
                  </div>
                ) : (
                  <MarkdownRenderer
                    content={block.content}
                    className="text-gray-700"
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
